import jwt_decode from 'jwt-decode'

let token = localStorage.getItem('kintsu-token') || null
let session = {
  session: {
    id: null,
    duration: null,
  },
  user: {
    id: null,
    role: null,
  },
  exp: null,
  iat: null,
}
let userAvatarUrl = null
let showSurvey = true
// let pharmaceuticalDomainConfig =
//   PHARMACEUTICAL_DOMAIN_CONFIG[location.hostname]?.default ?? PHARMACEUTICAL_DOMAIN_CONFIG.DEFAULT.default
// let defaultHomePage = 'home'
// let currentHomePage = localStorage.getItem('current-home-page') || null

if (token) {
  try {
    const decodedToken = jwt_decode(token)
    session = decodedToken
    userAvatarUrl = decodedToken.avatarUrl
    // pharmaceuticalDomainConfig = utils.parsePharmaceuticalDomainConfig(decodedToken, location.hostname)

    localStorage.setItem('kintsu-session', JSON.stringify(session))
  } catch (error) {
    console.error({ token, error })
  }
}

export default {
  token,
  session,
  userAvatarUrl,
  showSurvey,
  // pharmaceuticalDomainConfig,
  // defaultHomePage,
  // currentHomePage,
}
